import axios from 'axios';
import router from "@js/router";
import { useAuthStore } from "@stores";

export default function () {
    const authStore = useAuthStore();

    const onRequest = (request) => {
        const accessToken = localStorage.getItem('access-token');

        if (accessToken) {
            request.headers.Authorization = `Bearer ${accessToken}`;
            request.headers.Accept = 'application/json';
        }

        return request;
    };

    const onResponseError = async (error) => {
        if (error.response?.status === 401 && !error.config.isRetry) {
            error.config.isRetry = true;

            try {
                const { token } = await authStore.refreshToken();
                if (token) {
                    localStorage.setItem('access-token', token);
                    error.config.headers['Authorization'] = `Bearer ${token}`;

                    return axios.request(error.config);
                }
            } catch (refreshError) {
                localStorage.removeItem('access-token');
                await router.push({ name: 'Login' });

                return new Promise(() => {});
            }
        }

        return Promise.reject(error);
    };

    const onResponse = (response) => response;
    const onRequestError = (error) => Promise.reject(error);

    axios.defaults.baseURL = import.meta.env.VITE_AMOS_ENDPOINT;
    axios.interceptors.request.use(onRequest, onRequestError);
    axios.interceptors.response.use(onResponse, onResponseError);
}
